webpackJsonp([114276838955818,60335399758886],{

/***/ 118:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(208);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(118);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(49);
	var isArguments = __webpack_require__(48);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(56);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(47);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(55);
	
	var _HelmetConstants = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(50));
	var shallowEqual = _interopDefault(__webpack_require__(57));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = SiteFooter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(6);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _const = __webpack_require__(60);
	
	var _footerCover = __webpack_require__(549);
	
	var _footerCover2 = _interopRequireDefault(_footerCover);
	
	var _indexModule = __webpack_require__(315);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADDRESS = _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	        'strong',
	        null,
	        'Reinvent Software'
	    ),
	    _react2.default.createElement('br', null),
	    'The Hatch Lab',
	    _react2.default.createElement('br', null),
	    'M11 Business Campus',
	    _react2.default.createElement('br', null),
	    'Y25\xA0A8H2 Gorey',
	    _react2.default.createElement('br', null),
	    'Co. Wexford, Ireland'
	);
	
	function SiteFooter() {
	
	    var sectionStyle = {
	        backgroundImage: 'url(' + _footerCover2.default + ')',
	        backgroundSize: 'auto',
	        backgroundPosition: 'center bottom',
	        backgroundAttachment: 'fixed'
	        // backgroundRepeat: 'no-repeat',
	    };
	
	    return _react2.default.createElement(
	        _Section2.default,
	        { theme: 'darker', style: sectionStyle },
	        _react2.default.createElement(
	            _block2.default,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: _indexModule2.default.footerRow },
	                _react2.default.createElement(
	                    'div',
	                    { className: _indexModule2.default.cell },
	                    ADDRESS
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _indexModule2.default.cell },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Get in touch'
	                    ),
	                    'Drop us an email at',
	                    ' ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'mailto:' + _const.CONTACT_EMAIL },
	                        _const.CONTACT_EMAIL
	                    )
	                ),
	                _react2.default.createElement('div', { className: _indexModule2.default.cell })
	            )
	        )
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footerRow":"src-components-Footer----index-module---footerRow---3v4ii","cell":"src-components-Footer----index-module---cell---AJK7w"};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = SiteHead;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _favicon = __webpack_require__(58);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BASE_TITLE = 'Reinvent Software';
	var SITE_DESCRIPTION = 'We build modern, reliable software to help you work better.';
	
	function absoluteAssetURL(relativePath) {
	    // HACK
	    var path = relativePath.replace(/^\/+/, '');
	    return 'https://www.reinventsoftware.io/' + path;
	}
	
	function SiteHead(_ref) {
	    var title = _ref.title,
	        _ref$description = _ref.description,
	        description = _ref$description === undefined ? SITE_DESCRIPTION : _ref$description,
	        image = _ref.image,
	        children = _ref.children;
	
	    var siteTitle = BASE_TITLE;
	    if (title) {
	        siteTitle = title + ' - ' + siteTitle;
	    }
	    return _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	            'title',
	            null,
	            siteTitle
	        ),
	        _react2.default.createElement('link', { rel: 'icon', href: _favicon2.default }),
	        _react2.default.createElement('meta', { name: 'description', content: description }),
	        _react2.default.createElement('meta', { property: 'og:title', content: siteTitle }),
	        _react2.default.createElement('meta', { property: 'og:description', content: description }),
	        image && _react2.default.createElement('meta', { property: 'og:image', content: absoluteAssetURL(image) }),
	        children
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlx = __webpack_require__(193);
	
	var _reactPlx2 = _interopRequireDefault(_reactPlx);
	
	var _logo = __webpack_require__(207);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _navbar = __webpack_require__(225);
	
	var _indexModule = __webpack_require__(316);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_PARALLAX = [{
	    start: 0,
	    duration: 300,
	    properties: [{
	        property: 'backgroundColor',
	
	        // FIXME: do not hard-code value here
	        startValue: 'rgba(47, 37, 108, 0)',
	        endValue: 'rgba(47, 37, 108, 0.95)'
	    }]
	}];
	
	function NewHeader() {
	    return _react2.default.createElement(
	        _reactPlx2.default,
	        { parallaxData: HEADER_PARALLAX,
	            className: _indexModule2.default.StickyWrapper,
	            tagName: 'header' },
	        _react2.default.createElement(
	            'div',
	            { className: _indexModule2.default.HeaderContainer, style: { height: '60px' } },
	            _react2.default.createElement(
	                'div',
	                { className: _indexModule2.default.HeaderRow },
	                _react2.default.createElement(
	                    'div',
	                    { className: _indexModule2.default.logo },
	                    _react2.default.createElement(_logo2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _indexModule2.default.nav },
	                    _react2.default.createElement(MainNavbar, null)
	                )
	            )
	        )
	    );
	}
	
	exports.default = NewHeader;
	
	
	function MainNavbar() {
	    return _react2.default.createElement(
	        _navbar.Navbar,
	        null,
	        _react2.default.createElement(
	            _navbar.NavItem,
	            { to: '/products' },
	            'Products'
	        ),
	        _react2.default.createElement(
	            _navbar.NavItem,
	            { to: '/industries' },
	            'Industries'
	        ),
	        _react2.default.createElement(
	            _navbar.NavItem,
	            { to: '/technology' },
	            'Technology'
	        )
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"StickyWrapper":"src-components-Header----index-module---StickyWrapper---2PH6w","StickyWrapper--sticky":"src-components-Header----index-module---StickyWrapper--sticky---34pH7","HeaderContainer":"src-components-Header----index-module---HeaderContainer---3Arx1","Logo":"src-components-Header----index-module---Logo---2Pp_A","HeaderRow":"src-components-Header----index-module---HeaderRow---27hwb"};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexModule = __webpack_require__(318);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(556);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logo() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: _indexModule2.default.logo },
	            _react2.default.createElement('img', { src: _logo2.default, alt: '', className: _indexModule2.default.image }),
	            ' ',
	            _react2.default.createElement(
	                'span',
	                { className: _indexModule2.default.brandName },
	                _react2.default.createElement(
	                    'span',
	                    { className: _indexModule2.default.brandReinvent },
	                    'Reinvent'
	                ),
	                ' ',
	                _react2.default.createElement(
	                    'span',
	                    { className: _indexModule2.default.brandSoftware },
	                    'Software'
	                )
	            )
	        )
	    );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"logo":"src-components-logo----index-module---logo---3PlfJ","brandName":"src-components-logo----index-module---brandName---r2DHU","brandReinvent":"src-components-logo----index-module---brandReinvent---3fIuZ","brandSoftware":"src-components-logo----index-module---brandSoftware---2PrRa","image":"src-components-logo----index-module---image---MwEwY"};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/footer-cover-2.52e7d78d.jpg";

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAABLVSURBVHic7Z17VBPXvse/oQEUfKCiVgShWkCFiijyiEtLF7bW0tTWVbvO6UV7b5enXZULQS8+FlA7CMhLMCC1PmqPBT29RY59SFO6kEXVmgRBEURQEUQgCMpL3pCQ3D+8eKwnIa8ZZiby+U/Z2fs38/vOb/9m79l7A88piYmJr0skkgc1NTVDhw8fDqHbnnHGiNjYWMczZ85IBgYGVCMMDw+riouLO4RCoQ/d9o1DEQRBcI8fP37kwYMHwyoN9Pf3q0QiUVlqaupEuu0dh0TS09NDq6qq+jQ5/llaW1uVJ0+e/Dvddo9jJPHx8Svy8/NrlEqlrr7/E7du3RpIT0//K93XMY6eEARhm52d/Xtfn84PvUaGh4dVEonkYVpamjPd1zWOFgiCMDty5EhqY2Oj3GjPP0N3d7fqp59+khIEYUH3dY6jhpSUlKDS0tJHZDv+WZqamoaPHz+eRPf1jvP/xMXFLRWJRJXDwxqTe0q4fv16X0ZGxnq6r/+5hSCISVlZWWe6uroMy/BIQC6XqwoKCuqEQuFsuu/Hc8WhQ4di7t27N0SX45/l0aNHqpycnEK674vJk5SU9JZEInlIt8M1UVdXJz969Gg43ffJ5IiPj39ZJBKVKxQKun2sFaVSqRKLxR3r1q1bQPd9Yz0EQUw4ceJEVltb29hmeEbQ0tKi+uGHH1SWlpadAHYBYPRrI5duAzRx8ODB8LVr18Y4OztPoNsWXejt7UVxcTFu376N5uZmDA4OTgWQAOBjANsB/EKvhephnAASExMDvL29T/j7+9vTbYsuKBQKVFRUoLS0FHK5HABQX1//dBEXALkAzgEIA3BjzI0cBcYIgCCIWYsXL85+5513XrW0tKTbHJ2or6/HpUuX0N3d/af/b2hoUFd8DYBSAF8B2APgEeUG6gDtAiAIguvg4PAln8/fMnPmTDO67dGF1tZWiMViNDc3q/37MxHgacwBhAL4DwAxADIADFNho67QKoDU1NT/CggISF+yZMkkOu3QlYGBAVy9ehU3btyASqXSWK6xsVFbVTMACAF8hMfdwgXSjNQTWgSQmprqvWzZsu9Xr17txOFw6DBBL4aHh5/080NDQ6OWbWtrQ09Pj65VewI4j8c5QiiAu0YZagBjKgCCIGxdXV0z+Xz+m9bW1sz3PACZTIZLly6hs7NTp/Ia+n9tvA0gAEA6gDgA3aMXJ48xE8ChQ4di+Hz+bnt7e9rzDl3o7OyEVCodrT9Xi4ECAICJeDxuEAQgAkAWAM39DElQ7ozU1NQP/f39D3l6ek6lui0yGBwcRFlZGcrLy6FUKvX+vb6CUcNcAN8C+G8AAgASYyscDcoEsG/fPhd3d/fst956y+OFF16gqhnSUKlUuHPnDiQSCQYGBgyuhwQBjLACwCUAJwHsBKD+lcNISBcAQRBWCxYsOLl+/fp3J0+ezIp+vqmpCWKxGO3t7UbV09PTo3OuoCMcAJsAbACwH49HFg1XpxpIFcCJEyf2+Pv7Rzo6OjJ6/HuErq4uSKVS1NXVkVIfiU//s1gD+MLKyipo27ZtmXFxcXvJqpgUASQlJb25cuXKTB6PN5OM+qhGoVCgrKwM165dw/AweeMwFAoAfD4faWlpC1566aXod999N6ywsPBvO3fu/Kex9RolgJiYmJfc3Nz+ERgY6GthwYqHHtXV1SgqKkJfXx/pdRvxBqART09PCIVCrF69+sn/eXl5TVu6dGmOu7t71bVr1zZERETcNLR+gwRAEMQEJyenY2+//faHM2bMYMXwbXV1NSorK9HS0kJZG2RGgBkzZmDPnj0IDg6GuiSay+Vi3bp1i/z8/CrnzJmTK5FI/nL06FG9Va13kpaenv4/b7zxRqyrqysrpmllMhkiIiJgbW2NpUuXUtbO4OAgBALBqEPEumBubo6tW7ciOjoaU6fq/uZcW1s7lJeXty84ODhan/Z0fnoTExMDCgsLG0JCQvazwfn9/f1ITEzEokWLkJmZCQcHB0rbq6+vN9r5a9asQWlpKYRCoV7OB4D58+dbbN26lSgqKmpLTk4O1PV3WruAkWlaPp//6oQJjPc7ACA3NxehoaG4e/fx0LqVlRWmT59OaZvG9P8uLi5ITU1FYKDOftOIt7f3dE9Pz1xXV9ey8vLywKioKNlo5bVGgAULFny5ceNGVji/tLQUr776Kvh8/hPnA8C8efNA9aSTIQKwsbFBQkICrl+/TorzRzA3Nwefz/dwdHQUaivLinF5bbS1tSEmJgYZGRlqX+uoDv+AfgmgmZkZgoKCkJycjFmzZlFolXZYLQC5XI6vvvoKe/bswaNHmj+woVoACoUC9+/f16msv78/hEIhPDw8KLVJV1grgHPnziEsLAw3bmj/xG7evHmU2iKTybQOKDk4OCAuLg6bNm2i1BZ9YZ0Abt++je3bt+OXX3T7yNbCwgKzZ1O7cmu0/t/Kygo7d+7Erl27wMQ8ijUC6OzsREJCAg4cOKD1q5ynsbe3h5kZtWNV6gTA4XDw/vvvY//+/ZRHIGNgvACUSiVOnTqF8PBwPHjwQO/fj8XNfzYB9PLyQlpaGng8HuVtGwujh3F///13LFu2DJs3bzbI+QD1CaBSqYRM9vhV287ODkeOHEFRURErnA8wVAANDQ346KOP8Nprr6GsrMyouqgWQEtLC1QqFQQCAW7evIlPPvmE8i6HTBjVBfT19SE5ORkJCQlGfZUzgpmZGezs7EiwTDPTpk1DVVUV5s+fT2k7VMEIAahUKuTk5CA8PJzUGTU7OzuYm5uTVt/T2NjYgMfjwd6eFSvYNEK7AEpKSiAQCCAWi0mvm4oE0NLSEsuXL4ebmxvlw8tjAW0CaG9vR1hYGE6ePGn0LJomyOz/zczM4ObmhuXLl4MtH7/oAm0CKCsrQ1ZWFqVtkCWAuXPnws/Pj/IZRTqgvQugCg6HY3T/PHXqVKxYsYK1CZ4umKwAZs6ciYkTDdvz2dzcHEuWLMHSpUvVfo5lSpisAAxJADkcDpydneHj42OweNiGyQpA3/5/1qxZ4PF4tM/PjzUmKwBdI4C1tTW8vb3h7Px87gVtsgLQlgByuVx4eHjAw8MDXK7J3gatmOSV29jYYMqUKRr/Pn/+fPj6+mLSJFZsTEIpJikATeHf1tYWPB4PL7744hhbxFyeCwFYWVlh+fLlWLhwoUkM35KJSQpg5A3AzMwMixcvhpeXl0kN35KJyQrA0dERfn5+o+YC45igALy8vLB582bMnTuXblN0oqurC4ODg5g5k56V9ez5dEUL06dPR1paGqRSKSucr1KpkJWVBVdXV1RUVNBmB+sjAJfLxccff4zY2FjaniJ9uXz5MgQCAaRSKd2msFsAAQEBOHDgAF555RW6TdGJkaXqWVlZlH0DoS+s7AJefvllZGdn49y5c6xw/shS9YULFyIzM5MxzgdYFgGsra2xY8cO7N69G2zZUTw3NxchISGkbURFNqwQAIfDwaZNm5CYmMiaUbyrV68iLCwMFy9epNuUUWG8ALy9vZGWlgZfX1+6TdEJbUvVmQZjBTB37lzEx8cjKCiIFcO3ui5VZxqME8DEiRMRGhqKqKgo1szWnTt3DgKBAJWVlXSbojeMEgCfz0d6ejqcnJzoNkUnbt26he3bt0MkEtFtisEwQgDLli2DUCjEqlWr6DZFJzo6OpCYmKj3UnUmQqsAtG2GyDSMXarORGgTgLu7O2pra1kzWyeTyfDee++huLiYblNIhTYBsGXcvqenByUlJRCLxSbnfIAhOQATeXZHcSo2gmYC4wJQQ21tLaRS6Z9O/6JyK3g6GRfAUzx8+BBisVjtjuLjEcCE6evrw5UrV3Dz5k2NM3XjEcAEUXfwszq6u7tZNbyrD8+tADQd/KyprKny3AmgtbUVEolE5719gXEBmAS6HvysjnEBsBilUonKykqUlJQYPG5vqm8AgIkLQCaTQSwWo6Ojw+A6BgYG0NraSqJVzMIkBfDo0SNIJBJSQjcZZwExGZMSwNDQEK5cuYIbN24YdPCzOqgM/xwOB0FBQbQeHmESAhg5+FkqlaK/v5/UuqlKAL28vCAUCrFy5UpK6tcV1gugqakJEokEbW1tlNRPdgSws7PDF198gS1btjBiU2nWCqChoQH5+flQKBSUtSGXy9HcTM6p7RYWFvjss8+wd+9eRn0DQb8E9aSvrw/R0dFwcXF5sk8/VehyFpAu8Pl8VFVVQSgUMsr5AIsiwLM7iltaWlK+pZux4X/RokU4cOAA1q5dS5JF5MOKCFBSUoJVq1bhgw8+eJKU2dvbU75ewNAEcGSp+vXr1xntfIDhEaCpqQnR0dH4+uuv/+21jo6zgLQxslQ9Li4Otra2FFlFLowUwNDQEA4fPozPP/8cXV1dasuMxVlATU1NOpcPCAiAUCiEu7s7hVaRD+MEkJubC4FAgNra2lHLUR0BmpubdZo7cHZ2RlxcHDZu3EipPVTBGAFUVVVh27Zt+O2337SW5XK5mDNnDqX2aAv/kyZNQnh4OKuWqquDdgG0t7dj7969eq2mnTNnDuXbu2p6Axg5+DkpKYnyE0nHAtoEoFAo8M033yAyMlLv2Ta6EkAfHx+kpaXBx8eH8vbHCq2vgTU1NcGnT58+T8YxbiMUFBTA09MTn376qUFTrVQngCqVCo2NjU/+bW9vj8zMTEgkElY4Xy6X4+zZs2X37t0L01ZWawQgCOIBAP/Y2FhfHx+fU2vWrDH4/JTq6mpERkbi9OnThlYBgPoI0NbWhr6+PlhZWSEkJIRVS9XFYnHLH3/88dddu3YV6lJe75GUgwcPbnv99df3ubq66nwUdk9PD1JSUhAfH4/BwUF9m/wTHA4HaWlplCZepaWlaGtrQ3JyMhwdHSlrh0xqa2uH8vLyYoODg2P0+Z1BQ2kEQXAdHBy+XL9+/ZYZM2Zo7EZGVtPu2LFD7WILQ5g9ezb27t1LSl3qsLW1haurK9zc3Chrg0w6OztVubm5P9bU1HxIEITe/bRBSSBBEAoAnzY1NSW4ubn9IzAw0PfZzZiLioogEAhQVFRkSBMaoSr8s21HcYVCgfz8/Kpr165tiIiIuGloPaRcaVJS0psrV67M5PF4MxsbGxEZGUnZZogbNmwgdXydjTuKl5SUdJw/f35LeHj4GWPrIlXqSUlJ26Kjo//W29u7iMx6nyYsLAyLFpFTvZOTE3x9fRk3RauJuro6+dmzZ4WhoaE7yaqTilhnDmArgGgAU8muPCUlxeiM3MbGBn5+fpS/TpJFb28vRCLR+crKyncJgugks24qBoLkANIAnASwB0AwAFL2f5k2bZpRzh85+Hnx4sWM+BxLGyqVCgUFBbWXL19+LzIyspyKNqgcCWwDIADwLQAhAKN3gDI0ATQzM4OrqytWrFiBCRN0fnullYqKit6CgoJtYWFhx6hsZyyGgq8CWA2ADyAdgJOhFRkiADs7O/B4PNYc/Nzc3DwsEomONzQ0fEYQBDnfto/CWM4FnAVQACAEQBQAvWO5Pn32lClT4O3tzZqDn/v7+5GXlyetqqraEBkZqfvKVSMZ68mgPgCJeJwfxAMIgh6JqC4RYORASDYd/CwWi1suXrz4/u7du/8Y67bpmg2UAdgMIAOPE0atO0FbW1tj2rRpo5ZxcXGBt7c3rKysSDGSaqqqqvrz8/N3CQSCg3TZQPf3AJcB8ABswuPIoHEv+NGefrYd/Nze3q4SiUQ/1tTU/IUgCFq3GqVbAACgApAJ4J8AdgDYDeDfZnrUCYBtBz/L5XLk5eWVlZeX86Oiohix5pwJAhihFwCBx/nBPgB/+sju6QSQy+XC3d0dnp6eMDc3H0sbDeby5cvtFy5c+M8dO3acpduWp2GSAEa4A+ADAAEADgB4BfhXBHB0dASPx8PkyZNpM1Af7t69O/Trr7/GBwcHE3Tbwka4AD6ZMGHCw5ycHNX9+/dVbKGjo0P53XffiQiCYMeXJExmw4YNjkVFRa1KpZJuv2pFoVCofvzxx1tRUVGudN83k+PQoUOfVFdXD9LtZE2UlJS079+//32675PJc+rUqf/t6OhgTDiQyWSK48ePH6H7vjxXJCQkTBWJRGWDg/QFhJ6eHlV2dvbvBEHY0H0/nlvS09PXFBcXd4xlfqBUKlWFhYUNiYmJ7DjL7nng2LFjn9fX1yuodn5FRUWPUCj8lO7rHUcN2dnZL3z//fe5nZ2dpDu+ublZceLEiSyCIJg4djLO06SkpDgUFBTUyeVyox0/ODio+vnnn6/FxcVRuxp1HPJJT08PLC0t7TbU+ZcuXWpOSEhYTfd1jGMk3377bXpzc/Owro6/c+fOQEZGRgTddo9DIgRBWOTk5BT29vZqdHx7e7syKyvrDEEQ7FggMI7+pKamvnLhwgWZQvGvF4ahoSGVSCSq3Ldvnwvd9o0zRmRkZGy5ffv2oFQqbU1KSnqTbnvo4v8A+AioOKraJ2YAAAAASUVORK5CYII="

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(206);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(205);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Head = __webpack_require__(38);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	__webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_Head2.default, null),
	        _react2.default.createElement(_Header2.default, null),
	        _react2.default.createElement(
	            'div',
	            null,
	            children()
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	    );
	};
	
	TemplateWrapper.propTypes = {
	    children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Navbar = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.NavItem = NavItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(39);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(70);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navbarModule = __webpack_require__(323);
	
	var _navbarModule2 = _interopRequireDefault(_navbarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MENU_ICON = _react2.default.createElement(
	    'svg',
	    { fill: 'currentcolor', height: '24', viewBox: '0 0 24 24',
	        width: '24', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	);
	
	var Navbar = exports.Navbar = function (_React$Component) {
	    _inherits(Navbar, _React$Component);
	
	    function Navbar() {
	        _classCallCheck(this, Navbar);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args)));
	
	        _this.toggle = _this.toggle.bind(_this);
	        _this.state = { expanded: false };
	        return _this;
	    }
	
	    Navbar.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            placement = _props.placement,
	            className = _props.className,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['placement', 'className', 'children']);
	
	        var expanded = this.state.expanded;
	
	        var _className = (0, _classnames2.default)(_navbarModule2.default.navbar, placement, className);
	        return _react2.default.createElement(
	            'div',
	            _extends({ className: _className }, props),
	            _react2.default.createElement(
	                'div',
	                { className: _navbarModule2.default.nav },
	                _react2.default.createElement(
	                    NavbarMenu,
	                    { expanded: expanded,
	                        toggle: this.toggle,
	                        hide: function hide() {
	                            return _this2.setState({ expanded: false });
	                        } },
	                    children
	                )
	            )
	        );
	    };
	
	    Navbar.prototype.toggle = function toggle() {
	        this.setState({ expanded: !this.state.expanded });
	    };
	
	    return Navbar;
	}(_react2.default.Component);
	
	function NavbarMenu(_ref) {
	    var expanded = _ref.expanded,
	        toggle = _ref.toggle,
	        hide = _ref.hide,
	        children = _ref.children;
	
	    var _className = (0, _classnames2.default)(_navbarModule2.default.menu, expanded ? _navbarModule2.default['menu--expanded'] : _navbarModule2.default['menu--collapsed']);
	    return _react2.default.createElement(
	        'div',
	        { className: _className },
	        _react2.default.createElement(
	            'button',
	            { className: _navbarModule2.default.MenuToggle, onClick: toggle },
	            MENU_ICON
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: _navbarModule2.default.menu__links, onClick: hide },
	            children
	        )
	    );
	}
	
	function NavItem(_ref2) {
	    var children = _ref2.children,
	        className = _ref2.className,
	        active = _ref2.active,
	        disabled = _ref2.disabled,
	        props = _objectWithoutProperties(_ref2, ['children', 'className', 'active', 'disabled']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_navbarModule2.default.menu__item, { active: active }, className) },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            _extends({ className: (0, _classnames2.default)(_navbarModule2.default.menu__link, { disabled: disabled }) }, props),
	            children
	        )
	    );
	}

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nav":"src-ui-navbar----navbar-module---nav---3gyUy","menu":"src-ui-navbar----navbar-module---menu---3Wmuv","menu__links":"src-ui-navbar----navbar-module---menu__links---3hAmS","menu__link":"src-ui-navbar----navbar-module---menu__link---1xmRl","MenuToggle":"src-ui-navbar----navbar-module---MenuToggle---3y5Na","menu--collapsed":"src-ui-navbar----navbar-module---menu--collapsed---3A-IZ","menu--expanded":"src-ui-navbar----navbar-module---menu--expanded---3vunN"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3953e7edbb37b51c9f86.js